export enum RightLevelFlag {
  Read = 1 << 0, // 0001 -- the bitshift is unnecessary, but done for consistency
  Update = 1 << 1,     // 0010
  Create = 1 << 2,    // 0100
  Delete = 1 << 3,
  Admin = 1 << 4,
}